/**
 * Created by frank.law on 11/16/17.
 */
import React from 'react';
import '../../../css/login.css';
import {connect} from 'react-redux';
import FieldError from '../formFields/FieldError';
import {LocalForm} from 'react-redux-form';
import {submitTOTPVerifyChallenge, authCodeOnChange} from '../../actions/actions';
import PropTypes from 'prop-types';
import AuthCodeField from "../formFields/AuthCodeField";
import MessageAnchor from "../anchors/MessageAnchor"
import LoginUtils from '../../utils/LoginUtils';

class AuthCodeForm extends React.Component {

    handleSubmit(formValues) {
        const {token, challenge, submitTOTPVerify} = this.props;
        submitTOTPVerify(formValues.authcode, token, challenge);
    }


    render() {

        const {authCodeOnChange, title, authCodeSubtitle, authFieldValue, authCodeLabel, authCodePlaceholder, authFieldError, helpPrompt} = this.props;

        let errorField = [];
        if (authFieldError) {
            errorField = (<FieldError errorText={authFieldError}/>);
        }

        let noAuthCodeLink = [];
        if (helpPrompt) {
            noAuthCodeLink = (<MessageAnchor label={helpPrompt.label} linkType={'dark'} messageTitle={helpPrompt.label} messageBody={helpPrompt.value} challenge={'message'}/>);
        }

        return (
            <div key="AuthCodeForm_1">
                <LocalForm model="authCodeForm" className="login-form" onSubmit={(formValues) => this.handleSubmit(formValues)}>
                    <h4 className="has-subtitle">{title}</h4>
                    <span className="subtitle">{authCodeSubtitle}</span>
                    <AuthCodeField label={authCodeLabel} placeholder={authCodePlaceholder} onChangeFunc={authCodeOnChange} isError={(authFieldError && authFieldError.length > 0)} />
                    {noAuthCodeLink}
                    {errorField}
                    <button className="wdc-btn wdc-btn-primary" disabled={!(LoginUtils.checkAuthCodeValidity(authFieldValue))}>Authenticate</button>
                </LocalForm>
            </div>
        );
    }
}

AuthCodeForm.propTypes = {
    title: PropTypes.string,
    authCodeSubtitle: PropTypes.string,
    authFieldError: PropTypes.string,
    authCodeOnChange: PropTypes.func,
    submitAuthCodeForm: PropTypes.func,
    authCodeLabel: PropTypes.string,
    authCodePlaceholder: PropTypes.string,
    authFieldValue: PropTypes.string,
    helpPrompt: PropTypes.object,
    submitLabel: PropTypes.string,
    token: PropTypes.string,
    challenge: PropTypes.string
};

const mapStateToProps = (state) => {
    return {
        authFieldError: state.login.errorText,
        authFieldValue: state.forms.authCode,
        token: state.login.token,
        title: state.login.challengeResponse.title,
        authCodeLabel: state.login.challengeResponse.prompts.authCode.label,
        authCodePlaceholder: state.login.challengeResponse.prompts.authCode.placeholder,
        helpPrompt: state.login.challengeResponse.prompts.help,
        authCodeSubtitle: state.login.challengeResponse.prompts.authCodeSubtitle.label,
        submitLabel: state.login.challengeResponse.submitLabel,
        challenge: state.login.challengeResponse.nextChallenge
    };
};


const mapDispatchToProps = (dispatch) => {
    return {
        authCodeOnChange: (newValue) => {
            dispatch(authCodeOnChange(newValue))
        },
        submitTOTPVerify: (authCode, token, challenge) => {
            dispatch(submitTOTPVerifyChallenge(authCode, token, challenge));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(AuthCodeForm);
